/* eslint-disable eqeqeq */
import {
  Box,
  Checkbox,
  Container,
  Divider,
  IconButton,
  Link,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import AppBaseScreen from "../../components/AppBaseScreen";
import AppButton from "../../components/AppButton";
import { styles, theme } from "./theme";
import AppListDate from "../../components/AppListDate";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { connectBank, fetchNotification, getAppConfigurations, getCurrencies, getDashboardData, getMerchants, getPayeeData, getPockytConnectedBanks, getReccuringRules, getSerivceProvider } from "../../store/actions";
import { findSymbol, formatNumber, getSymbol, isFunction, isMfaEnforced } from "../../utils";
import AppKycStatus from "../../components/AppKycStatus";
import InfoIcon from "@mui/icons-material/Info";
import AppToolTip from "../../components/AppTooltip";
import AppScreenLoader from "../../components/AppScreenLoader";
import AppDialogHalfScreen from "../../components/AppDialogHalfScreen";
import AppNotificationPopup from "../../components/AppNotificationPopup";
import Cross from "../../assets/logo/cross.svg";
import { Check, Close } from "@mui/icons-material";
import TimerIcon from "../../assets/logo/timer.svg";
import { getPayoutOrders, logEvent } from "../../store/api";
import { ACTIVITY_DETAIL, ACTIVITY_META, EVENTS } from "../../utils/events";
import { useLocation } from "react-router-dom";
import FeedbackSurvey from "../withdraw/components/FeedbackSurvey";
import { createSelector } from "@reduxjs/toolkit";
import AppHomeBankList from "../../components/AppHomeBankList";
import { SET_MERCHANT } from "../../store/actions/actionTypes";
import AppMenuItem from '../../components/AppMenuItem';
import AlarmClock from '../../assets/logo/alarmclock.svg';
import { fetchReferalSettings } from "../../store/actions/ReferalActions";
import { getReferalSelector } from "../../utils/selectorHelpers";

const Home = () => {
  const dashboardData = useSelector(({ dashboard }) => dashboard);
  const shouldShowTemporaryDelay = () => {
    return localStorage.getItem("service-delay-popshown") != 1
  }

  const [serviceDisruptionOpen,
    setServiceDisruptionOpen] = React.useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const user = useSelector(({ Auth }) => Auth.user);
  const account = useSelector(({ Auth }) => Auth.account);
  const refer = useSelector(getReferalSelector);
  const accounts = useSelector(({ Auth }) => Auth.accounts || []);
  const symbols = useSelector(getSymbol);

  // use memoization when certain state changes the refrences frequently
  const selectRecurring = (state) => state.recurring;
  const selectRecurringRules = createSelector(
    [selectRecurring],
    (recurring) => recurring?.rules || []
  );
  const recurringRules = useSelector(selectRecurringRules);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notification = useSelector(({ Auth }) => Auth.notification);
  const [showNotificationPop, setShowNotificationPop] = useState(false);
  const [showMFAPop, setShowMFAPop] = useState(false);
  const [showStatementMenuPop, setShowStatementMenuPop] = useState(false);
  const [checked, setChecked] = useState(false);
  const [popupQueue, setPopupQueue] = useState({});
  const [statementCheck, setStatementCheck] = useState(false);
  const location = useLocation();
  const removeFromPopQueue = (key) => {
    setPopupQueue((prev) => {
      return {
        ...prev,
        [key]: null
      };
    })
  }
  const updatePopQueueAction = (key, action) => {
    setPopupQueue((prev) => {
      return {
        ...prev,
        [key]: {
          action: action
        }
      };
    })
  }
  const handleServiceDisruption = (result) => {
    if (shouldShowTemporaryDelay()) {
      updatePopQueueAction('serviceDelay', () => {
        setServiceDisruptionOpen(Boolean(result.isServiceDelayed));
      })
    }
  }

  const handleServiceDisruptionClose = () => {
    setServiceDisruptionOpen(false);
    localStorage.setItem("service-delay-popshown", 1);
    removeFromPopQueue('serviceDelay');
  };
  const handlePopUp = (userData) => {
    if (Object.keys(userData || {}).length > 0) {
      const isChecked = localStorage.getItem("mfa-pop");
      const shownmfa = localStorage.getItem("shownmfa");
      if (!userData.isMfaEnabled && shownmfa !== "true" && isChecked !== "true" && showStatementMenuPop === false && !showNotificationPop) {
        updatePopQueueAction('mfa', () => {
          setShowMFAPop(true);
          localStorage.setItem("shownmfa", JSON.stringify(true));
        })

        return;
      } else if (Object.keys(userData).length && showMFAPop === false && !showNotificationPop) {
        updatePopQueueAction('statement', () => {
          showStatementMenuPopup(1);
        })

      }
    }
  }

  // Check for notification popup after notification is fetched
  useEffect(() => {
    if (notification && notification.isEnabled && notification.subject && notification.description && dashboardData.fetched) {
      const notificationKey = `notification-${notification.subject}-shown`;
      const sessionNotification = sessionStorage.getItem("notification-shown");
      const hasShownThisSession = sessionNotification === notificationKey;
      const hasShownBefore = !notification.showEveryTime && localStorage.getItem(notificationKey) === "true";
      const shouldShowNotification = !hasShownThisSession && (!hasShownBefore || notification.showEveryTime);
      if (shouldShowNotification && !showNotificationPop) {
        updatePopQueueAction('notification', () => {
          setShowNotificationPop(true);
          sessionStorage.setItem("notification-shown", notificationKey);
          if (!notification.showEveryTime) {
            localStorage.setItem(notificationKey, "true");
          }
          // Track notification popup opened
          logEvent({
            current: EVENTS['NOTIFICATION']['NOTIFICATION_OPENED'],
            activity: ACTIVITY_DETAIL['NOTIFICATION']['NOTIFICATION_OPENED'],
            meta: {
              data: {
                pathname: location.pathname,
                notificationSubject: notification.subject,
                showEveryTime: notification.showEveryTime
              }
            }
          });
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification, dashboardData.fetched]);
  useEffect(() => {
    dispatcher();
    if (!account && accounts?.length > 0) {
      navigate('/accounts')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (account) {
      dispatch(fetchNotification());
    }
  }, [account, dispatch]);
  const dispatcher = async () => {
    dispatch(getPayeeData(handlePopUp));
    dispatch(fetchNotification());
    dispatch(getMerchants());
    dispatch(getCurrencies());
    dispatch(connectBank(false));
    dispatch(getPockytConnectedBanks());
    dispatch(fetchReferalSettings());
    dispatch(getAppConfigurations());
  }

  useEffect(() => {
    if (account && Object.keys(account)?.length) {
      dispatch(getDashboardData());
      dispatch(getReccuringRules());
      dispatch(getSerivceProvider(handleServiceDisruption));
      dispatch(getPockytConnectedBanks());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);
  useEffect(() => {
    if (dashboardData.fetched) {
      // Show notification first, then MFA, then statement, then service delay
      if (popupQueue.notification?.action && isFunction(popupQueue.notification?.action)) {
        popupQueue.notification.action()
      } else if (popupQueue.mfa?.action && isFunction(popupQueue.mfa?.action)) {
        popupQueue.mfa.action()
      } else if (popupQueue.statement?.action && isFunction(popupQueue.statement?.action)) {
        popupQueue.statement.action()
      } else if (popupQueue.serviceDelay?.action && isFunction(popupQueue.serviceDelay.action)) {
        popupQueue.serviceDelay.action()
      }
    }

  }, [popupQueue, dashboardData.fetched, notification]);
  const handleWithdrawNavigation = () => {
    if (notification?.isEnabled) {
      return;
    }
    navigate("/withdraw");
  };

  const handleCloseMfa = () => {
    if (checked) {
      localStorage.setItem("mfa-pop", true);
    }
    handleSetShowMFAPop(false);
    logEvent({
      current: EVENTS['2FA']['2FA_DISMISS'],
      activity: ACTIVITY_DETAIL['2FA']['2FA_DISMISS'],
      meta: {
        data: {
          pathname: location.pathname,
          source: ACTIVITY_META.KYC.FROM_DASHBOARD,
          doNotShowChecked: checked
        }
      }
    });
  };

  const handleMFACheckBox = (event) => {
    setChecked(event.target.checked);
  };
  const handleSattementCheckBox = (event) => {
    setStatementCheck(event.target.checked);
  };

  const navigateToMfa = () => {
    navigate("/mfa/1");
  };

  const showStatementMenuPopup = (wind) => {
    const isChecked = localStorage.getItem("statement-pop");
    const shown = localStorage.getItem("statement-popshown");
    if (shown !== "true") {
      if (isChecked !== "true") {
        setShowStatementMenuPop(refer?.isEnabled);
        localStorage.setItem("statement-popshown", JSON.stringify(true));
        return;
      }
    }
    removeFromPopQueue('statement');
  }

  const handleSetShowNotificationPop = (value) => {
    setShowNotificationPop(value);
    if (!value) {
      removeFromPopQueue('notification');
      // After notification closes, check for MFA popup
      const isChecked = localStorage.getItem("mfa-pop");
      const shownmfa = localStorage.getItem("shownmfa");
      if (!user?.isMfaEnabled && shownmfa !== "true" && isChecked !== "true") {
        updatePopQueueAction('mfa', () => {
          setShowMFAPop(true);
          localStorage.setItem("shownmfa", JSON.stringify(true));
        });
      } else {
        updatePopQueueAction('statement', () => {
          showStatementMenuPopup(4);
        });
      }
    }
  };

  const handleSetShowMFAPop = (value) => {
    setShowMFAPop(value);
    if (!value) {
      removeFromPopQueue('mfa');
    }
    updatePopQueueAction('statement', () => {
      showStatementMenuPopup(4);
    })

  };
  const handleCloseStatement = () => {
    if (statementCheck) {
      localStorage.setItem("statement-pop", true);
    }
    setShowStatementMenuPop(false);
    removeFromPopQueue('statement');
    logEvent({
      current: EVENTS['STATEMENTS']['STATEMENT_DISMISS'],
      activity: ACTIVITY_DETAIL['STATEMENTS']['STATEMENT_DISMISS'],
      meta: {
        data: {
          pathname: location.pathname,
          source: ACTIVITY_META.KYC.FROM_DASHBOARD,
          doNotShowChecked: checked
        }
      }
    });
  };

  const handleMerchantChange = (account) => {
    dispatch({
      type: SET_MERCHANT,
      payload: account
    })
  }
  const hasAccounts = accounts?.length > 0;
  const isTransferDisabled = notification?.isEnabled || !hasAccounts;
  if ((!dashboardData?.fetched || !account) && accounts?.length > 0) {
    return <AppScreenLoader />;
  }
  const renderMfaPopup = () => {
    return (
      <AppDialogHalfScreen show={showMFAPop || isMfaEnforced()} onChangeShow={handleSetShowMFAPop}>
        <Container disableGutters>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            marginTop={2}
          >
            <Box>
              <Typography variant="h5" color={"#F8FAFF"}>
                {isMfaEnforced() ? t("2fa-title1") : t("2fa-title")}
              </Typography>
            </Box>
            {!isMfaEnforced() && <IconButton onClick={handleCloseMfa} aria-label="tracker" aria-describedby="mfa_popup_close">
              <Cross
                aria-label="tracker" aria-describedby="mfa_popup_close"
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                }}
              />
            </IconButton>}
          </Box>

          <Typography variant="subtitle2" color={"#F8FAFF"} marginTop={3}>
            {t("2fa-subtitle")}
          </Typography>
          <Box display={"flex"} alignItems={"flex-start"} flexDirection={"row"}>
            <Typography variant="subtitle2" color={"#F8FAFF"} marginTop={2}>
              {t("check")}
            </Typography>
            <Typography variant="subtitle2" color={"#F8FAFF"} marginTop={2}>
              &nbsp;{t("2fa-p1")}
            </Typography>
          </Box>
          <Box display={"flex"} alignItems={"flex-start"} flexDirection={"row"}>
            <Typography variant="subtitle2" color={"#F8FAFF"} marginTop={1}>
              {t("check")}
            </Typography>
            <Typography variant="subtitle2" color={"#F8FAFF"} marginTop={1}>
              &nbsp;{t("2fa-p2")}
            </Typography>
          </Box>

          <Typography
            variant="subtitle2"
            color={"#F8FAFF"}
            marginTop={3}
            data-i18n={`[html]2fa-p3`}
          >
            <Trans
              components={{
                a: (
                  <Link href="mailto:support@rocketfuel.inc" target="_blank" />
                ),
              }}
            >
              {t("2fa-p3")}
            </Trans>
          </Typography>
          <Typography
            variant="subtitle2"
            fontSize={16}
            color={"#F8FAFF"}
            marginTop={2}
          >
            {t("status")}: {t("Off")}
          </Typography>
          <AppButton
            sx={{ width: 90, margin: "auto", fontSize: 12 }}
            title={t("setup")}
            onClick={navigateToMfa}
          ></AppButton>
          {!isMfaEnforced() && <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            marginTop={2}
            justifyContent={"center"}
            marginLeft={-5}
          >
            <Checkbox
              checked={checked}
              onChange={handleMFACheckBox}
              name="Mfa check box"
              sx={{
                color: "#737373",
              }}
              checkedIcon={<Check />}
            />
            <Typography color={"#F8FAFF"} variant="subtitle2">
              {t("dnshow")}
            </Typography>
          </Box>}
        </Container>
      </AppDialogHalfScreen>
    );
  };
  const renderStatementPopup = () => {
    return <AppDialogHalfScreen show={showStatementMenuPop} onChangeShow={setShowStatementMenuPop}>
      <Container disableGutters>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          marginTop={2}
        >
          <Box>
            <Typography variant="h5" color={"#F8FAFF"}>
              {t("invite.title")}!
            </Typography>
          </Box>
          <IconButton onClick={handleCloseStatement} aria-label="tracker" aria-describedby="statment_popup_close">
            <Cross
              aria-label="tracker" aria-describedby="statment_popup_close"
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
              }}
            />
          </IconButton>
        </Box>
        <Typography variant="subtitle2" color={"#F8FAFF"} marginTop={3} >
          {t("invite.sub1").replace('%refererPayeeReward%', refer?.rewardCurrencySymbol + refer?.refererPayeeReward)
            .replace('%referredPayeeReward%', refer?.rewardCurrencySymbol + refer?.referredPayeeReward)}
        </Typography>
        <Typography variant="subtitle2" color={"#F8FAFF"} marginTop={3} >
          {t("invite.sub2").replace('%refererPayeeReward%', refer?.rewardCurrencySymbol + refer?.refererPayeeReward)
            .replace('%referredPayeeReward%', refer?.rewardCurrencySymbol + refer?.referredPayeeReward)}
        </Typography>
         <Typography variant="subtitle2" color={"#F8FAFF"} marginTop={2}>{t('invite.sub3').replace('%refererPayeeReward%', refer?.rewardCurrencySymbol + refer?.refererPayeeReward)
          .replace('%referredPayeeReward%', refer?.rewardCurrencySymbol + refer?.referredPayeeReward)}</Typography>
        <AppButton onClick={() => navigate('/refer')} title={t("invite.button.popup")} buttontheme="light"></AppButton>
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          marginTop={2}
          justifyContent={"center"}
          marginLeft={-5}
        >
          <Checkbox
            checked={statementCheck}
            onChange={handleSattementCheckBox}
            name="Settlement checkbox"
            sx={{
              color: "#737373",
            }}
            checkedIcon={<Check />}
          />
          <Typography color={"#F8FAFF"} variant="subtitle2">
            {t("dnshow")}
          </Typography>
        </Box>
      </Container>
    </AppDialogHalfScreen>
  }
  return (
    <AppBaseScreen isHeader={true} showLocale={true}>
      <ThemeProvider theme={theme}>
        <AppNotificationPopup
          show={showNotificationPop}
          onChangeShow={handleSetShowNotificationPop}
          notification={notification}
        />
        {renderMfaPopup()}
        {renderStatementPopup()}
        {location.state?.showFeedbackForm && <FeedbackSurvey customWaitTime={2} />}
        <AppKycStatus
          kycStatus={parseFloat(user?.kycStatus?.toString())}
          mismatch={user?.kycMismatch}
        />
        {serviceDisruptionOpen ? <Box
          sx={{
            position: 'relative'
          }}>
          <Box
            sx={{
              backgroundColor: '#0088f526',
              borderRadius: '8px',
              padding: '8px 20px',
              minHeight: '75px',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: 'center'
            }}>
            <Box sx={{
              width: "20px"
            }}>
              <AlarmClock style={{
                width: '100%'
              }} />
            </Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: '16px',
                padding: '6px 0'
              }}>
              {t('temporarily.delayed')}
            </Typography>
            <Typography>
              {t('temporarily.description')}
            </Typography>
          </Box>
          <IconButton
            onClick={() => handleServiceDisruptionClose()}
            sx={{
              padding: 1,
              position: "absolute",
              top: 0,
              right: 0,
              background: "transparent"
            }}
          >
            <Close />
          </IconButton>
        </Box> : null}
        <Box margin={1} />
        <AppHomeBankList />
        <AppMenuItem
          items={accounts}
          onItemSelect={handleMerchantChange}
          defaultValue={account}
          labelKey="merchantName"
          identifierKey="merchantId"
          labelKey2Identifier={"totalBalance"}
          labelKey2Text={"availableBalance"}
        />

        {!!dashboardData.balanceOnHold && (
          <Box marginTop={1.5} display={"flex"} flexDirection={"row"} alignItems={'center'}>
            <Typography fontSize={16} color={"#D4D4D8"}>
              {t("homePage.currentBalance")}
            </Typography>
            <Typography fontSize={16} color={"#D4D4D8"}>
              &nbsp;&nbsp; {findSymbol(symbols, account)} {formatNumber(dashboardData.totalBalance)}
            </Typography>
            &nbsp;&nbsp;&nbsp;
            <AppToolTip
              enterTouchDelay={0}
              title={`Transaction in review ${findSymbol(symbols, account)} ${formatNumber(
                dashboardData.balanceOnHold
              )}`}
              placement="top"
              arrow
            >
              <InfoIcon sx={{ color: "#D4D4D8", cursor: "pointer" }} />
            </AppToolTip>
          </Box>
        )}
        <Box display={"flex"} flexWrap={"wrap"} flexDirection={"row"} justifyContent={'space-between'} marginTop={2}>
          <AppToolTip
            enterTouchDelay={0}
            title={!hasAccounts ? t("homePage.noAccountTransferTip") : ""}
            placement="top"
            arrow
          >
            <span style={{ width: isSmallScreen ? "100%" : "45%" }}>
              <AppButton
                disabled={isTransferDisabled}
                title={t("homePage.withdraw")}
                onClick={handleWithdrawNavigation}
                sx={{ width: '100%' }}
              />
            </span>
          </AppToolTip>
          <AppButton
            disabled={user?.kycStatus != 2 || notification?.isEnabled}
            title={!recurringRules.length ? t("recurring.setup") : t("viewRecurringTransfers")}
            startIcon={<TimerIcon style={styles.icon} />}
            buttontheme={"outlined"}
            onClick={() => navigate("/recurring-payment")}
            sx={{ width: isSmallScreen ? '100%' : '48%' }}
          />
        </Box>
        <Divider variant="middle" />
        <Typography fontSize={17} paddingBottom={1} fontWeight={600}>
          {t("homePage.transactions")}:
        </Typography>
        <AppListDate
          title={t("homePage.transactions")}
          getData={account ? getPayoutOrders : () => []}
        />
      </ThemeProvider>
    </AppBaseScreen>
  );
};

export default Home;
